import React, { useState, useEffect } from 'react'
import { Col, FlexboxGrid, Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import SettingEditFormWidget from '../dynamicForm/SettingEditFormWidget'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import { saveSettingFormProjectAttachments } from '../../../redux/actions/subProjectFormSetting'
import notification from '../../../utils/notification'
import { cloneDeep } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import InputForm from '../../../components/forms/input/InputForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import ProposalAttachmentsSettingForm from './ProposalAttachmentsSettingForm'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ProposalAttachmentsSettingWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [addNewIndex, setAddNewIndex] = useState(0)
  const [notiMsg, setNotiMsg] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isRefash, setIsRefash] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [delIds, setDelIds] = useState([])
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormProjectAttachments(formId, request)
      if (response?.forms?.attachments) {
        setFormSchema(response.forms.attachments)
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    data.attachments?.forEach((e) => {
      let value = data[e.name] || null
      values.push({
        key: e.id,
        name: e.name,
        value: Array.isArray(value) ? value.join(',') : value,
        type: e.type,
        refId: e.refId,
      })
    })

    let request = {
      id: formSchema.id,
      detail: data.detail || null,
      note: data.note || null,
      values: values,
      valuesDelIds: data.attachmentDelIds || [],
      descValues: data.descSettingValues || [],
      descDelIds: data.descDelIds || [],
    }

    // console.log('request : ', request)

    handleSave(request)
  }

  const onRefash = (isNotSet) => {
    // if (!isNotSet) {
    //   setFormSchema(props.schema)
    // }
    setDelIds([])
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  // const onAdd = (index) => {
  //   let schema = cloneDeep(formSchema)

  //   let newObj = { ...schema?.objects?.findLast((e) => e) }
  //   let newId = 'NEW_' + (addNewIndex + 1)
  //   if (newObj) {
  //     newObj.id = newId
  //     newObj.name = newId
  //     newObj.value = null
  //     newObj.label = 'รายการใหม่ ' + (addNewIndex + 1)
  //   } else {
  //     newObj = {
  //       id: newId,
  //       name: newId,
  //       label: 'รายการใหม่ ' + (addNewIndex + 1),
  //       value: null,
  //       type: 'INPUT',
  //       viewGoup: '1',
  //       EnableDel: true,
  //       validators: {
  //         type: 'REQUIRED',
  //         errorMessage: 'กรุณาระบุ',
  //       },
  //     }
  //   }

  //   schema?.objects?.push(newObj)
  //   setAddNewIndex(addNewIndex + 1)
  //   setFormSchema(schema)
  // }

  // const onRemove = (item) => {
  //   let schema = cloneDeep(formSchema)
  //   //console.log('onRemove item : ', item)
  //   //console.log('schema.objects : ', schema.objects)
  //   let index = schema?.objects?.findIndex((e) => e.name == item.name)
  //   //console.log('onRemove index : ', index)
  //   schema.objects.splice(index, 1)
  //   if (!item.id.startsWith('NEW_')) {
  //     setDelIds([...delIds, item.id])
  //   }
  //   setFormSchema(schema)
  // }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {!isRefash && (
        <>
          <ProposalAttachmentsSettingForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            // onAdd={onAdd}
            // onRemove={onRemove}
          />
          {/* <SettingEditFormWidget
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onAdd={onAdd}
            onRemove={onRemove}
          /> */}
        </>
      )}

      <hr />
      {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(`${pathname.subProjectNew.proposal.attachments}?preView`, '_blank')
          }}
          children={'แสดงตัวอย่าง'}
        />
        <SaveButton
          children={SAVE + formSchema.buttonText || ''}
          disabled={isLoading}
          onClick={handleSubmit(onSubmit)}
        />
        <CancelButton children={CANCEL} onClick={onRefash} />
      </div>

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
